import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const PaginationButtons = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}) => {
  const [pageInput, setPageInput] = useState("");

  const handlePageInputChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {
      setPageInput(value);
    }
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(pageInput, 10);

    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
      setPageInput("");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleGoToPage();
    }
  };
  const renderPageNumbers = () => {
    const pages = [];
    pages.push(
      <button
        key={1}
        onClick={() => onPageChange(1)}
        className={
          currentPage === 1 ? "pagination-selected-btn" : "pagination-btn"
        }
      >
        1
      </button>
    );

    if (totalPages <= 7) {
      for (let page = 2; page <= totalPages; page++) {
        pages.push(
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={
              currentPage === page
                ? "pagination-selected-btn"
                : "pagination-btn"
            }
          >
            {page}
          </button>
        );
      }

      return pages;
    }

    if (currentPage <= 2) {
      pages.push(
        <button
          key={2}
          onClick={() => onPageChange(2)}
          className={
            currentPage === 2 ? "pagination-selected-btn" : "pagination-btn"
          }
        >
          2
        </button>
      );

      pages.push(
        <button
          key={3}
          onClick={() => onPageChange(3)}
          className={
            currentPage === 3 ? "pagination-selected-btn" : "pagination-btn"
          }
        >
          3
        </button>
      );
      pages.push(
        <span key="ellipsis-start" className="ellipsis pt-1">
          ...
        </span>
      );
      pages.push(
        <button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className="pagination-btn"
        >
          {totalPages}
        </button>
      );

      return pages;
    }
    if (currentPage >= totalPages - 3) {
      pages.push(
        <span key="ellipsis-start" className="ellipsis pt-1">
          ...
        </span>
      );
      for (let page = totalPages - 4; page <= totalPages; page++) {
        pages.push(
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={
              currentPage === page
                ? "pagination-selected-btn"
                : "pagination-btn"
            }
          >
            {page}
          </button>
        );
      }

      return pages;
    }
    pages.push(
      <span key="ellipsis-start" className="ellipsis pt-1">
        ...
      </span>
    );

    for (let page = currentPage - 1; page <= currentPage + 1; page++) {
      pages.push(
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={
            currentPage === page ? "pagination-selected-btn" : "pagination-btn"
          }
        >
          {page}
        </button>
      );
    }

    pages.push(
      <span key="ellipsis-end" className="ellipsis pt-1">
        ...
      </span>
    );

    pages.push(
      <button
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
        className="pagination-btn"
      >
        {totalPages}
      </button>
    );

    return pages;
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-wrapper flex-rows flex-justify-center flex-align-center gap-50 ">
      <div className="pagination-controls flex-align-center">
        <button
          className="small"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        <div className="page-numbers flex-rows">{renderPageNumbers()}</div>

        <button
          className="small"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          <FontAwesomeIcon icon={faChevronRight} className="chevron" />
        </button>
      </div>

      {totalPages > 5 && (
        <div className="page-input-container flex-rows gap-10 flex-align-center  width-25p ">
          <span className="page-input-label">Go to page:</span>

          <input
            type="text"
            className="page-input"
            value={pageInput}
            onChange={handlePageInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Page #"
            aria-label="Page number"
          />

          <button
            className="small"
            onClick={handleGoToPage}
            disabled={
              !pageInput ||
              parseInt(pageInput, 10) < 1 ||
              parseInt(pageInput, 10) > totalPages
            }
          >
            Go
          </button>
        </div>
      )}
    </div>
  );
};

export default PaginationButtons;
